/* =========================================================
   MANEWAY POLICY PAGES
   Turns Shopify policy text (paragraphs with bold lines as
   headings) into numbered sections, builds "On this page",
   highlights the section in view and links email addresses.
   Markup: snippets/mw-policy-page.liquid. Styles: mw-policy.css.
   Without this script the policy still reads fine as plain text.
========================================================= */

(function () {
  'use strict';

  var MINOR = /^(a|an|and|as|at|but|by|for|in|of|on|or|the|to|with)$/;

  function titleCase(text) {
    // Only rewrite headings written (mostly) in capitals.
    var letters = text.replace(/[^A-Za-z]/g, '');
    var upper = text.replace(/[^A-Z]/g, '');
    if (!letters.length || upper.length / letters.length < 0.6) return text;
    return text.toLowerCase().replace(/[a-z][a-z'’]*/g, function (word, index) {
      return index > 0 && MINOR.test(word) ? word : word.charAt(0).toUpperCase() + word.slice(1);
    });
  }

  function slugify(text, used) {
    var slug = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
    var base = slug;
    var n = 2;
    while (used[slug]) slug = base + '-' + n++;
    used[slug] = true;
    return slug;
  }

  function textOf(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent.replace(/\s+/g, ' ').trim();
  }

  /* Split the policy into [{ title, html }] using bold lines as headings. */
  function parseSections(rte) {
    var html = rte.innerHTML
      .replace(/<\/p>\s*<p[^>]*>/gi, '<br><br>')
      .replace(/^\s*<p[^>]*>/i, '')
      .replace(/<\/p>\s*$/i, '');

    var chunks = html.split(/(?:\s*<br\s*\/?>\s*){2,}/i);
    var sections = [{ title: null, parts: [] }];

    chunks.forEach(function (chunk) {
      chunk = chunk.trim();
      if (!chunk) return;

      var match = chunk.match(/^<(strong|b)>([\s\S]*?)<\/\1>\s*(?:<br\s*\/?>)?/i);
      var heading = match ? textOf(match[2]) : '';

      if (match && heading && heading.length <= 120) {
        sections.push({ title: heading, parts: [] });
        var rest = chunk.slice(match[0].length).trim();
        if (rest) sections[sections.length - 1].parts.push(rest);
      } else {
        sections[sections.length - 1].parts.push(chunk);
      }
    });

    return sections;
  }

  function linkEmails(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) {
      if (/[\w.+-]+@[\w-]+\.[\w.]+/.test(walker.currentNode.nodeValue) && !walker.currentNode.parentElement.closest('a')) {
        nodes.push(walker.currentNode);
      }
    }
    nodes.forEach(function (node) {
      var span = document.createElement('span');
      span.innerHTML = node.nodeValue
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/([\w.+-]+@[\w-]+\.[\w.]+[\w])/g, '<a href="mailto:$1">$1</a>');
      node.replaceWith.apply(node, Array.prototype.slice.call(span.childNodes));
    });
  }

  function init() {
    var article = document.querySelector('[data-mw-policy-article]');
    if (!article || article.mwReady) return;
    article.mwReady = true;

    var body = article.querySelector('.shopify-policy__body');
    var rte = body && (body.querySelector('.rte') || body);
    var plain = rte ? rte.textContent.replace(/\s+/g, ' ').trim() : '';

    if (!plain) {
      var empty = document.querySelector('[data-mw-policy-empty]');
      if (empty) empty.hidden = false;
      return;
    }

    var words = plain.split(' ').length;
    var sections = rte.querySelector('h2, h3') ? null : parseSections(rte);
    var used = {};
    var toc = [];

    if (sections && sections.length > 2) {
      var out = '';
      var number = 0;

      sections.forEach(function (section) {
        var paragraphs = section.parts.map(function (p) { return '<p>' + p + '</p>'; }).join('');

        if (!section.title) {
          if (paragraphs) out += '<div class="mw-policy__intro">' + paragraphs + '</div>';
          return;
        }

        number += 1;
        var title = titleCase(section.title);
        var id = slugify(title, used);
        toc.push({ id: id, title: title });

        out +=
          '<section class="mw-policy__section" id="' + id + '">' +
            '<h2 class="mw-policy__heading">' +
              '<span class="mw-policy__num">' + (number < 10 ? '0' : '') + number + '</span>' +
              '<span>' + title.replace(/</g, '&lt;') + '</span>' +
            '</h2>' +
            (paragraphs ? '<div class="mw-policy__section-body">' + paragraphs + '</div>' : '') +
          '</section>';
      });

      rte.innerHTML = out;
    } else {
      // Already structured with headings: just number them for the list.
      rte.querySelectorAll('h2, h3').forEach(function (h) {
        var title = h.textContent.trim();
        h.id = h.id || slugify(title, used);
        toc.push({ id: h.id, title: title });
      });
    }

    article.classList.add('is-enhanced');
    linkEmails(rte);

    // Hero chips.
    var meta = document.querySelector('[data-mw-policy-meta]');
    if (meta) {
      meta.querySelector('[data-mw-policy-read]').textContent = Math.max(1, Math.round(words / 220)) + ' min read';
      var countChip = meta.querySelector('[data-mw-policy-count]');
      if (toc.length) countChip.textContent = toc.length + ' sections';
      else countChip.remove();
      meta.hidden = false;
    }

    if (toc.length < 2) return;

    // "On this page".
    var aside = document.querySelector('[data-mw-policy-aside]');
    var list = document.querySelector('[data-mw-policy-toc-list]');
    var details = document.querySelector('[data-mw-policy-toc]');
    list.innerHTML = toc.map(function (item) {
      return '<li><a href="#' + item.id + '" data-mw-toc-link="' + item.id + '">' + item.title.replace(/</g, '&lt;') + '</a></li>';
    }).join('');
    aside.hidden = false;
    document.querySelector('.mw-policy').classList.add('has-toc');

    var isMobile = window.matchMedia('(max-width: 989px)');
    if (isMobile.matches) details.open = false;

    list.addEventListener('click', function (event) {
      if (event.target.closest('a') && isMobile.matches) details.open = false;
    });

    // Highlight the section in view.
    if ('IntersectionObserver' in window) {
      var links = {};
      list.querySelectorAll('[data-mw-toc-link]').forEach(function (a) { links[a.getAttribute('data-mw-toc-link')] = a; });
      var current = null;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (current) current.classList.remove('is-active');
          current = links[entry.target.id];
          if (current) current.classList.add('is-active');
        });
      }, { rootMargin: '-25% 0px -65% 0px' });

      toc.forEach(function (item) {
        var el = document.getElementById(item.id);
        if (el) observer.observe(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
